import React, { type PropsWithChildren } from 'react';
import { PaidFeatureAwarenessPremiumLozenge } from '@atlassian/jira-paid-feature-awareness-renderer/src/ui/lozenges/index.tsx';
import { useIsPremiumLozengeVisible } from '../controllers/index.tsx';

export const PremiumLozenge = ({ children }: PropsWithChildren): React.JSX.Element => {
	const isVisible = useIsPremiumLozengeVisible();

	return isVisible ? <PaidFeatureAwarenessPremiumLozenge /> : <>{children}</>;
};
